module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-26-7da137914d790b4cbfe620bdcfa3470e.jpg";